import * as Utils from '../../../utils';
import { ApplicationStateKeys } from '../constants/Application';

export function getDeviceId(state) {
  return state.device.get(ApplicationStateKeys.DEVICE_ID);
}

export function getDeviceUuid(state) {
  const isDeviceUuidEnabled = Utils.TunerVars.deviceUuidEnabled(state);

  const stateDeviceUuid = state.device.get(ApplicationStateKeys.DEVICE_UUID);

  return isDeviceUuidEnabled && stateDeviceUuid
    ? state.device.get(ApplicationStateKeys.DEVICE_UUID)
    : state.device.get(ApplicationStateKeys.DEVICE_ID);
}

export default {
  getDeviceId,
  getDeviceUuid,
};
